import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getPorkFootprintByYear, getPorkFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_PORK } from "consts";

export const useGetFootprintingPorkFootprint = (farmId?: string, year?: number, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const { user } = useUserContext();
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const enableQuery = isAdmin
    ? (enabled && !!farmId && !!year) ?? false
    : (enabled && !!farmId && !!year && !!user && carbonProgram?.platformFeatures?.footprinting?.pork && !!token) ?? false;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_PORK, farmId, year, isAdmin],
      queryFn: async () => (isAdmin ? getPorkFootprintByYearAdmin(farmId ?? "", year ?? 0) : getPorkFootprintByYear(year ?? 0)),
      enabled: enableQuery,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
